
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 640 640","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M640 318.18c0 175.61-143.39 318.18-320 318.18S0 493.79 0 318.18 143.39 0 320 0s320 142.57 320 318.18z","id":"a"}}),_c('path',{attrs:{"d":"M437.7 313.51c0 63.97-53.64 115.91-119.7 115.91s-119.7-51.94-119.7-115.91S251.94 197.6 318 197.6s119.7 51.94 119.7 115.91z","id":"b"}})]),_c('use',{attrs:{"xlink:href":"#a","fill":"#666"}}),_c('use',{attrs:{"xlink:href":"#b","fill":"#fff"}})])
          )
        }
      }
    